import { Autocomplete, Box, Button, MenuItem, TextField } from '@mui/material';
import { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { CampaignContext } from '../../contexts/CampaignContext';
import { MAX_PACKAGES_PAGE_LIMIT } from '../../constants/numbers';
import { useParams } from 'react-router-dom';

interface Props {
	isProvincialActive?: boolean;
	setFiltersAnchorEL?: Dispatch<SetStateAction<HTMLButtonElement | null>>;
	value: any | null;
	setValue: (val: any) => void;
}

const FilterCampaignBox: FC<Props> = ({ isProvincialActive, setFiltersAnchorEL, value, setValue }) => {
	const { type } = useParams();
	const { selectedPlatformId, setFetchedPackages, setFetchedEntites, setFetchedEntitiesPagination } = useContext(CampaignContext);
	const [options, setOptions] = useState<any[]>([]);
	const [_, setInputValue] = useState('');

	const { t } = useTranslation();
	const handleFilter = () => {
		axios<IResponse<any>>({
			method: 'get',
			url: `/media_entities`,
			params: {
				campaign_type: type,
				media_id: selectedPlatformId?.toString(),
				limit: MAX_PACKAGES_PAGE_LIMIT.toString(),
				location_id: isProvincialActive ? value?.id : '',
				category_id: !isProvincialActive ? value?.id : '',
			},
		}).then(res => {
			if (res.data.success) {
				setFetchedEntites(res.data.data);
				setFetchedPackages(res.data.data);
				setFetchedEntitiesPagination(res.data.pagination);
				setFiltersAnchorEL?.(null);
			}
		});
	};

	useEffect(() => {
		if (isProvincialActive) {
			(async () => {
				axios({
					url: '/locations',
					params: {
						type: 'province',
					},
				}).then(res => {
					if (res.data.success) {
						// let filterlist = res.data.data.filter((item: any) => item.type === 'province');
						setOptions(res.data.data);
					}
				});
			})();
		} else {
			(async () => {
				axios({
					url: '/options/category',
				}).then(res => {
					if (res.data.success) {
						setOptions(res.data.data);
					}
				});
			})();
		}
	}, []);

	return (
		<Box className="flex w-full items-center gap-x-5">
			<Box className="w-64 gap-x-5">
				<Autocomplete
					getOptionLabel={option => option.title}
					options={options}
					autoComplete
					includeInputInList
					filterSelectedOptions
					value={value}
					onChange={(_, newValue) => {
						setValue(newValue);
					}}
					noOptionsText={t('no_rows')}
					onInputChange={(_, newInputValue) => {
						setInputValue(newInputValue);
					}}
					filterOptions={(options, { inputValue }) => options.filter(option => option.title.includes(inputValue))}
					renderOption={(props, option) => {
						return (
							<MenuItem {...props} key={option.id}>
								{option.title}
							</MenuItem>
						);
					}}
					renderInput={params => <TextField {...params} label={isProvincialActive ? t('province') : t('category')} fullWidth />}
				/>
			</Box>
			<div className="flex gap-x-4">
				<Button variant="outlined" onClick={handleFilter}>
					{t('applyـfilter')}
				</Button>
			</div>
		</Box>
	);
};

export default FilterCampaignBox;
